import React from 'react';
import { Users, Home, UserPlus, Heart, User, Book, Shield, MessageSquare, Building, Crown, Calendar } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

const HomePage = () => {
  const navigate = useNavigate();

  const pages = [
    { name: 'Home', path: '/', icon: Home },
    { name: 'Sign Up / Login', path: '/auth', icon: UserPlus },
    { name: 'Matches', path: '/matches', icon: Heart },
    { name: 'Profile', path: '/profile', icon: User },
    { name: 'Tester Guide', path: '/guide', icon: Book },
    { name: 'Admin', path: '/admin', icon: Shield },
  ];

  const handleNavigation = (path: string) => {
    navigate(path);
  };

  return (
    <div>
      <header className="container mx-auto px-4 py-12 md:py-24 text-center">
        <div className="flex items-center justify-center mb-8">
          <Users className="w-8 h-8 md:w-10 md:h-10 text-primary-400 mr-3" />
          <h1 className="text-3xl md:text-5xl font-serif italic text-primary-400">Homie</h1>
        </div>
        <p className="text-xl md:text-2xl font-serif italic text-primary-600 mb-6 max-w-2xl mx-auto leading-relaxed">
          Join our curated community of mindful roommates creating harmonious shared spaces in Brooklyn.
        </p>
        <p className="text-base md:text-lg text-primary-500 mb-12 max-w-xl mx-auto">
          We carefully review each application to ensure our community remains a safe, respectful space for everyone.
        </p>

        {/* Direct Access Section */}
        <div className="max-w-4xl mx-auto mb-12 bg-cream-100 p-4 md:p-6 rounded-lg shadow-md">
          <h2 className="text-xl md:text-2xl font-serif text-primary-600 mb-4">Testing Direct Access</h2>
          <p className="text-gray-600 mb-6">
            Skip login completely and access pages directly for testing
          </p>
          
          <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
            <button
              onClick={() => navigate('/matches')}
              className="p-4 border border-gray-200 rounded-lg hover:border-primary-300 hover:bg-primary-50 transition-all duration-300"
            >
              <Heart className="w-6 h-6 text-primary-400 mx-auto mb-2" />
              <p className="text-sm text-center">Matches</p>
            </button>
            
            <button
              onClick={() => navigate('/admin')}
              className="p-4 border border-gray-200 rounded-lg hover:border-primary-300 hover:bg-primary-50 transition-all duration-300"
            >
              <Shield className="w-6 h-6 text-primary-400 mx-auto mb-2" />
              <p className="text-sm text-center">Admin</p>
            </button>
            
            <button
              onClick={() => navigate('/landlord')}
              className="p-4 border border-gray-200 rounded-lg hover:border-earth-300 hover:bg-earth-50 transition-all duration-300"
            >
              <Building className="w-6 h-6 text-earth-400 mx-auto mb-2" />
              <p className="text-sm text-center">Landlord</p>
            </button>
            
            <button
              onClick={() => navigate('/profile')}
              className="p-4 border border-gray-200 rounded-lg hover:border-primary-300 hover:bg-primary-50 transition-all duration-300"
            >
              <User className="w-6 h-6 text-primary-400 mx-auto mb-2" />
              <p className="text-sm text-center">Profile</p>
            </button>
            
            <button
              onClick={() => navigate('/listings')}
              className="p-4 border border-gray-200 rounded-lg hover:border-primary-300 hover:bg-primary-50 transition-all duration-300"
            >
              <Home className="w-6 h-6 text-primary-400 mx-auto mb-2" />
              <p className="text-sm text-center">Listings</p>
            </button>
            
            <button
              onClick={() => navigate('/users')}
              className="p-4 border border-gray-200 rounded-lg hover:border-primary-300 hover:bg-primary-50 transition-all duration-300"
            >
              <Users className="w-6 h-6 text-primary-400 mx-auto mb-2" />
              <p className="text-sm text-center">Users</p>
            </button>
            
            <button
              onClick={() => navigate('/monetization')}
              className="p-4 border border-gray-200 rounded-lg hover:border-primary-300 hover:bg-primary-50 transition-all duration-300"
            >
              <Crown className="w-6 h-6 text-yellow-500 mx-auto mb-2" />
              <p className="text-sm text-center">Monetization</p>
            </button>
            
            <button
              onClick={() => navigate('/events')}
              className="p-4 border border-gray-200 rounded-lg hover:border-primary-300 hover:bg-primary-50 transition-all duration-300"
            >
              <Calendar className="w-6 h-6 text-primary-400 mx-auto mb-2" />
              <p className="text-sm text-center">Events</p>
            </button>
          </div>
        </div>

        <div className="flex flex-col items-center gap-4">
          <button 
            onClick={() => handleNavigation('/auth')}
            className="bg-primary-400 text-cream-50 px-8 py-3 rounded-md font-serif text-lg hover:bg-primary-500 transition-all duration-300 shadow-sm hover:shadow-md"
          >
            Apply to Join
          </button>
          <button
            onClick={() => handleNavigation('/auth')}
            className="text-primary-400 hover:text-primary-500 font-serif text-lg"
          >
            Already have an account? Log in
          </button>
        </div>
      </header>

      {/* Feedback Section */}
      <div className="fixed bottom-4 right-4">
        <button
          onClick={() => handleNavigation('/guide')}
          className="flex items-center gap-2 px-4 py-2 bg-white rounded-full shadow-lg hover:shadow-xl transition-all duration-300"
        >
          <MessageSquare className="w-5 h-5 text-primary-400" />
          <span className="text-primary-600">Give Feedback</span>
        </button>
      </div>
    </div>
  );
};

export default HomePage;